import { render, staticRenderFns } from "./uploadPanel.vue?vue&type=template&id=77063556&scoped=true&"
import script from "./uploadPanel.vue?vue&type=script&lang=js&"
export * from "./uploadPanel.vue?vue&type=script&lang=js&"
import style0 from "./uploadPanel.vue?vue&type=style&index=0&id=77063556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77063556",
  null
  
)

export default component.exports